import { useState, useCallback } from 'react';
import { authAPI, formatApiErrorDetail } from '../utils/api';
import { toast } from 'sonner';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // Memoized to be stable for useEffect dependencies
  const checkAuth = useCallback(async () => {
    try {
      await authAPI.getMe();
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setIsCheckingAuth(false);
    }
  }, []); // Empty deps: authAPI and setters are stable

  const login = useCallback(async (email, password) => {
    setIsLoading(true);
    try {
      await authAPI.login(email, password);
      setIsAuthenticated(true);
      toast.success('Accesso effettuato con successo');
      return true;
    } catch (error) {
      const errorMsg = formatApiErrorDetail(error.response?.data?.detail);
      toast.error(errorMsg || 'Credenziali non valide');
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []); // Empty deps: all used values are stable

  const logout = useCallback(async () => {
    try {
      await authAPI.logout();
      setIsAuthenticated(false);
      toast.success('Logout effettuato');
    } catch (error) {
      toast.error('Errore durante il logout');
    }
  }, []); // Empty deps: all used values are stable

  return {
    isAuthenticated,
    isCheckingAuth,
    isLoading,
    checkAuth,
    login,
    logout
  };
};
